<template>
  <div>
    <nav class="navbar is-dark is-hidden-desktop">
      <div class="container">
        <div class="navbar-brand">
          <div class="navbar-item">
            <div class="field has-addons search">
              <div class="is-flex">
                <div class="control">
                  <input
                    v-model="value"
                    class="input"
                    type="text"
                    placeholder="Member Search"
                    @keyup.enter="search()"
                  >
                </div>
                <div
                  class="control"
                  @click="search()"
                >
                  <a class="button is-dark">
                    <span class="icon is-right">
                      <i class="far fa-search" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            class="navbar-burger burger"
            :class="{'is-active': isActive}"
            data-target="navMenubd-example"
            @click="toggleActive()"
          >
            <span />
            <span />
            <span />
          </div>
        </div>
        <navigation
          :is-active="isActive"
          @hideMenuInMobile="hideMenuInMobile"
          @search="search"
        />
      </div>
    </nav>
    <section class="hero hero-header">
      <div class="container">
        <div class="hero-head">
          <img
            class="logo"
            src="/images/dps.png"
          >
        </div>
        <div class="hero-foot">
          <nav class="navbar is-transparent is-hidden-touch">
            <div
              class="navbar-burger burger"
              :class="{'is-active': isActive}"
              data-target="navMenubd-example"
              @click="toggleActive()"
            >
              <span />
              <span />
              <span />
            </div>
            <navigation
              :is-active="isActive"
              @hideMenuInMobile="hideMenuInMobile"
              @search="search"
            />
          </nav>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
.navbar-burger {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
<script>
  import Navigation from './Navigation.vue'
  export default {
    name: 'Header',
    components: {
      Navigation
    },
    data () {
      return {
        value: '',
        isActive: false
      }
    },
    methods: {
      toggleActive () {
        this.isActive = !this.isActive
      },
      hideMenuInMobile () {
        this.isActive = false
      },
      search () {
        this.$emit('search', this.value)
      }
    }
  }
</script>
